
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, CircularProgress, FormControl, InputLabel, Select, MenuItem, TextField, Paper } from '@mui/material'

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';
import { useFilter } from '../../hooks/useFilter';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout'
import { SearchTextField } from '../../components/SearchTextField';

import { ObtenerTipoAcuerdo } from '../../connections/catalogos/TipoAcuerdoConnection';
import { ActualizarSubTipoAcuerdo, AgregarSubTipoAcuerdo, SubTipoAcuerdos } from '../../connections/catalogos/SubTipoAcuerdoConnection';

import { TipoAcuerdoProps } from '../../interfaces/catalogos/TipoAcuerdoInterface';
import { SubTipoAcuerdoProps } from '../../interfaces/catalogos/SubTipoAcuerdoInterface';

export const SubTipoAcuerdoPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [idSubTipoAcuerdo, setIdSubTipoAcuerdo] = useState( 0 );
    const [SubTipoAcuerdo, setSubTipoAcuerdo] = useState<SubTipoAcuerdoProps[]>( [] );

    const [tipoAcuerdo, setTipoAcuerdo] = useState( 0 );
    const [tipoAcuerdoArray, setTipoAcuerdoArray] = useState<TipoAcuerdoProps[]>( [] );

    const [descripcion, setDescripcion] = useState( '' );

    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );

    const [filtroTipoAcuerdo, setFiltroTipoAcuerdo] = useState( '' );

    const { filtro, setFiltro, dataFiltrada } = useFilter( SubTipoAcuerdo, ( item, filtro ) => {
        const f = filtro.toLowerCase();
        const fta = filtroTipoAcuerdo.toLowerCase();
        return (
            ( filtro === '' || ( item.descripcion?.toLowerCase().includes( f ) ?? false ) ) &&
            ( filtroTipoAcuerdo === '' || ( item.tipoAcuerdo?.descripcion?.toLowerCase().includes( fta ) ?? false ) )
        );
    });

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const SubTipoAcuerdoselected = SubTipoAcuerdo.find( (elem) => elem.idSubTipoAcuerdo === id );

        if ( SubTipoAcuerdoselected ) {

            await ActualizarSubTipoAcuerdo({ ...SubTipoAcuerdoselected, activo: checked }).then( resp => {

                if ( resp.idSubTipoAcuerdo ) {

                    var newArray = SubTipoAcuerdo.map( (elem) => {

                        if ( elem.idSubTipoAcuerdo === id ) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setSubTipoAcuerdo( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));
                }

            });
        }

    }

    const handleChangeCheckedListaAcuerdo = async ( checked: boolean, id: number ) => {

        const SubTipoAcuerdoselected = SubTipoAcuerdo.find( (elem) => elem.idSubTipoAcuerdo === id );

        if ( SubTipoAcuerdoselected ) {

            await ActualizarSubTipoAcuerdo({ ...SubTipoAcuerdoselected, listaAcuerdo: checked }).then( resp => {

                if ( resp.idSubTipoAcuerdo ) {

                    var newArray = SubTipoAcuerdo.map( (elem) => {

                        if ( elem.idSubTipoAcuerdo === id ) {
                            elem.listaAcuerdo = checked;
                        }

                        return elem;
                    });

                    setSubTipoAcuerdo( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));
                }

            });
        }

    }

    const handleGuardar = async () => {

        if ( idSubTipoAcuerdo !== 0 ) {

            const SubTipoAcuerdoSelected = SubTipoAcuerdo.find( (elem) => elem.idSubTipoAcuerdo === idSubTipoAcuerdo );

            if ( SubTipoAcuerdoSelected ) {

                setLoading( true );

                await ActualizarSubTipoAcuerdo({ ...SubTipoAcuerdoSelected, descripcion, idTipoAcuerdo: tipoAcuerdo }).then( resp => {

                    if ( resp.idSubTipoAcuerdo ) {

                        setTimeout(() => {

                            var newArray = SubTipoAcuerdo.map( (elem) => {

                                if ( elem.idSubTipoAcuerdo === idSubTipoAcuerdo ) {
                                    elem.descripcion = descripcion;
                                    elem.idTipoAcuerdo = tipoAcuerdo;
                                    elem.tipoAcuerdo = resp.tipoAcuerdo
                                }

                                return elem;
                            });

                            setSubTipoAcuerdo( newArray );
                            setOpenDialog( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });
            }

        }
        else {

            const SubTipoAcuerdoAdd: SubTipoAcuerdoProps = {
                idSubTipoAcuerdo: 0,
                descripcion,
                idTipoAcuerdo: tipoAcuerdo,
                listaAcuerdo: true,
                activo: true,
            };

            setLoading( true );

            await AgregarSubTipoAcuerdo( SubTipoAcuerdoAdd ).then( resp => {

                if ( resp.idSubTipoAcuerdo ) {

                    setTimeout(() => {

                        setSubTipoAcuerdo( [...SubTipoAcuerdo, resp] );
                        setOpenDialog( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó el sub tipo de acuerdo correctamente', variant: 'success' }));

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData( true );
            setSubTipoAcuerdo( [] );

            await SubTipoAcuerdos().then( resp => {

                setTimeout(() => {

                    setSubTipoAcuerdo( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function obtener() {

            setTipoAcuerdoArray( [] );

            await ObtenerTipoAcuerdo().then( resp => {

                setTimeout(() => {

                    setTipoAcuerdoArray( resp );

                }, 700);

            });

        }

        obtener();

    }, [])

    return (

        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Subtipo de acuerdos' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ xs: 6 }} textAlign={ 'start' }>

                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={ 'end' }>

                    <Button
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {

                            setIdSubTipoAcuerdo( 0 );
                            setTipoAcuerdo( 0 );
                            setDescripcion( '' );

                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }} spacing={ 2 }>

                <Grid size={{ xs: 12, md: 6 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>

                    <SearchTextField
                        value={ filtroTipoAcuerdo }
                        label='Buscar por tipo de acuerdo'
                        onChange={ ( value ) => {
                            setFiltroTipoAcuerdo( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '45%', }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%' }}> Tipo Acuerdo </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', textAlign: 'center' }}> Públicar en la lista de acuerdos </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                    :
                                    dataFiltrada
                            )
                                .map( ({ idSubTipoAcuerdo, descripcion, activo,listaAcuerdo, idTipoAcuerdo, tipoAcuerdo,  }) => (

                                    <TableRow key={ idSubTipoAcuerdo } >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            { idSubTipoAcuerdo }
                                        </TableCell>

                                        <TableCell>
                                            { descripcion }
                                        </TableCell>

                                        <TableCell>
                                            { tipoAcuerdo?.descripcion }
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Switch
                                                checked={ listaAcuerdo }
                                                onChange={ ( e ) => handleChangeCheckedListaAcuerdo( e.target.checked, idSubTipoAcuerdo ) }
                                            />
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={ activo }
                                                onChange={ (e) => handleChangeChecked( e.target.checked, idSubTipoAcuerdo ) }
                                            />

                                            <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={ () => {

                                                    setIdSubTipoAcuerdo( idSubTipoAcuerdo );
                                                    setTipoAcuerdo( idTipoAcuerdo? idTipoAcuerdo: 0 );
                                                    setDescripcion( descripcion );

                                                    setOpenDialog( true );
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={ 7 } align='center'>

                                            <CircularProgress size={ 32 } />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={ 2 } sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: { dataFiltrada.length }
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={  [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                    colSpan={ 8 }
                                    count={ dataFiltrada.length }
                                    rowsPerPage={ rowsPerPage }
                                    page={ page }

                                    onPageChange={ handleChangePage }
                                    onRowsPerPageChange={ handleChangeRowsPerPage }

                                    ActionsComponent={ TablePaginationActions }

                                    labelRowsPerPage='Filas por página'
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={ openDialog } maxWidth='sm' fullWidth={ true }>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>
                                <InputLabel>Tipo Acuerdo</InputLabel>

                                <Select
                                    label='TipoAcuerdo'
                                    value={ tipoAcuerdo }
                                    onChange={ (e) => setTipoAcuerdo( parseInt(e.target.value.toString() ?? '0') ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        tipoAcuerdoArray.map( (elem) => (
                                            <MenuItem key={ elem.idTipoAcuerdo } value={ elem.idTipoAcuerdo }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <TextField
                                label={ 'Descripción' }
                                variant='outlined'
                                multiline
                                rows={ 4 }
                                fullWidth
                                value={ descripcion }
                                onChange={ (e) => setDescripcion( e.target.value ) }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                            />

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => { setOpenDialog( false ); } }> Cancelar </Button>
                    <Button loading={ loading } disabled={ tipoAcuerdo === 0 } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}
